module.exports = __webpack_public_path__ + "img/logo.e3eb202d.png";